"use client";

import { SparklesIcon } from "lucide-react";
import type { AiProviderInfo } from "./contexts/aiProviderContext";

export function ProviderIcon({ provider, className }: {
  provider: Pick<AiProviderInfo, "iconPath" | "displayName" | "name">;
  className?: string;
}) {
  if (provider.iconPath) {
    return (
      <img
        src={provider.iconPath}
        alt={provider.displayName ?? provider.name}
        className={className}
      />
    );
  }
  return <SparklesIcon className={className} />;
}
